import type { Enums } from "@msuite/utils/types";
import { Tag, type TagProps } from "./tag";

type Status = "idle" | "warning" | "error" | "success" | "pending" | "info" | "default";

/** Props Interface */
interface StatusTagProps extends Partial<TagProps> {
	status: Status | undefined;
}

export function StatusTag({ status, variant = "default" }: StatusTagProps) {
	/** Guard */
	if (!status) return null;

	/** Render */
	return (
		<Tag
			color={getStatusColor(status)}
			variant={variant}
		>
			{status}
		</Tag>
	);
}

function getStatusColor(status: Status): Enums<"color"> {
	switch (status) {
		case "idle":
			return "amber";
		case "warning":
			return "yellow";
		case "error":
			return "red";
		case "success":
			return "emerald";
		case "pending":
			return "blue";
		case "info":
			return "blue";
		case "default":
			return "gray";
	}
}
